import React, { useContext } from 'react'
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../Contexts/AuthContext';

const BecomeVerifiedMember = () => {

    const { token, user, setIsLoginModal } = useContext(AuthContext);

    return (
        <section className="w-full bg-gradient-radial py-12 lg:py-15">
            <div className="container mx-auto px-4 lg:px-15">
                <div className="flex flex-col items-center">
                    <div className="p-6 sm:p-10 lg:p-16 border border-white rounded-lg shadow-lg">
                        <h2
                            className="text-4xl sm:text-4xl lg:text-5xl font-bold font-urbanist text-white text-center mb-10 lg:mb-10">
                            Become a Verified FWPI Member
                        </h2>
                        <div className="flex flex-col items-center gap-6">
                            <ul className="space-y-4 text-left">
                                <li className="flex items-start gap-4">
                                    <img className="w-6 h-6 lg:w-7 lg:h-7 flex-shrink-0 rounded-full"
                                        src="/assets/check-list.png" alt="check-list" />
                                    <p className="text-neutral-200 sm:text-lg text-xl">
                                        <strong className="font-bold">Register in Minutes:</strong> Complete our simple
                                        onboarding
                                        form.
                                    </p>
                                </li>
                                <li className="flex items-start gap-4">
                                    <img className="w-6 h-6 lg:w-7 lg:h-7 flex-shrink-0 rounded-full"
                                        src="/assets/check-list.png" alt="check-list" />
                                    <p className="text-neutral-200 sm:text-lg text-xl">
                                        <strong className="font-bold">Professional Website:</strong> Present your profile and
                                        services with impact.
                                    </p>
                                </li>
                                <li className="flex items-start gap-4">
                                    <img className="w-6 h-6 lg:w-7 lg:h-7 flex-shrink-0 rounded-full"
                                        src="/assets/check-list.png" alt="check-list" />
                                    <p className="text-neutral-200 sm:text-lg text-xl">
                                        <strong className="font-bold">Showcase Expertise:</strong> Highlight your certifications
                                        and achievements.
                                    </p>
                                </li>
                                <li className="flex items-start gap-4">
                                    <img className="w-6 h-6 lg:w-7 lg:h-7 flex-shrink-0 rounded-full"
                                        src="/assets/check-list.png" alt="check-list" />
                                    <p className="text-neutral-200 sm:text-lg text-xl">
                                        <strong className="font-bold">Nationwide Presence:</strong> Be listed on India’s trusted
                                        professional network.
                                    </p>
                                </li>
                                <li className="flex items-start gap-4">
                                    <img className="w-6 h-6 lg:w-7 lg:h-7 flex-shrink-0 rounded-full"
                                        src="/assets/check-list.png" alt="check-list" />
                                    <p className="text-neutral-200 sm:text-lg text-xl">
                                        <strong className="font-bold">Quality Client Leads:</strong> Receive direct enquiries
                                        from
                                        genuine prospects.
                                    </p>
                                </li>
                                <li className="flex items-start gap-4">
                                    <img className="w-6 h-6 lg:w-7 lg:h-7 flex-shrink-0 rounded-full"
                                        src="/assets/check-list.png" alt="check-list" />
                                    <p className="text-neutral-200 sm:text-lg text-xl">
                                        <strong className="font-bold">Career & Income Growth:</strong> Build credibility and
                                        expand
                                        your reach.
                                    </p>
                                </li>
                            </ul>
                            {
                                !!token ?
                                    (
                                        user?.role === 'user' ?
                                            <Link to='/trainer/create' className="mt-5 px-8 py-4 bg-white rounded-xl !text-neutral-950 text-base sm:text-base lg:text-lg font-medium font-inter leading-10 hover:!text-neutral-950 focus:!text-neutral-950 hover:shadow-[0px_0px_5px_5px_rgba(171,198,248,0.5)] transition-shadow">
                                                Register Now
                                            </Link>
                                            :
                                            <Link to='/my-profile' className="mt-5 px-8 py-4 bg-white rounded-xl !text-neutral-950 text-base sm:text-base lg:text-lg font-medium font-inter leading-10 hover:!text-neutral-950 focus:!text-neutral-950 hover:shadow-[0px_0px_5px_5px_rgba(171,198,248,0.5)] transition-shadow">
                                                Register Now
                                            </Link>
                                    )
                                    :
                                    <button type='button' onClick={() => { setIsLoginModal(true); }} className="mt-5 px-8 py-4 bg-white rounded-xl !text-neutral-950 text-base sm:text-base lg:text-lg font-medium font-inter leading-10 hover:!text-neutral-950 focus:!text-neutral-950 hover:shadow-[0px_0px_5px_5px_rgba(171,198,248,0.5)] transition-shadow">
                                        Register Now
                                    </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BecomeVerifiedMember;